export default __webpack_public_path__ + "static/media/h_wdt_c_1.aaa4c602.mp3";